module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/how_to_enjoy_photography_case3-8b17d3d623f49eed44da2d53206fda98.jpg";